import { addSaga } from './add'
import { getTraineesBySectorSaga } from './getTraineesBySector'
import { uploadPublicProjectFileSaga } from './uploadProjetPublic'
import { deleteTraineesBySectorSaga } from './deleteTraineesBySector'
import { editTraineesSaga } from './editTraineesBySector'
import { getOneTraineesBySectorSaga } from './getOneTraineesBySector'
import { getBtsHistorySaga } from './getBtsHistory'
import { deleteBtsHistorySaga } from './deleteBtsHistory'
import { getSocioEcoHistorySaga } from './getSocioEcoHistory'
import { deleteSocioEcoHistorySaga } from './deleteSocioEcoHistory'
import { getPublicProjectHistorySaga } from './getPublicProjectHistory'
import { deletePublicProjectHistorySaga } from './deletePublicProjectHistory'
import { deleteSocioEcoSaga } from './deleteSocioEco'
import { editSocioEcoSaga } from './editSocioEco'

const CollectDataSagas = [
    addSaga,
    getTraineesBySectorSaga,
    uploadPublicProjectFileSaga,
    deleteTraineesBySectorSaga,
    editTraineesSaga,
    getOneTraineesBySectorSaga,
    getBtsHistorySaga,
    deleteBtsHistorySaga,
    getSocioEcoHistorySaga,
    deleteSocioEcoHistorySaga,
    getPublicProjectHistorySaga,
    deletePublicProjectHistorySaga,
    deleteSocioEcoSaga,
    editSocioEcoSaga,
]

export default CollectDataSagas
